module.exports = __webpack_public_path__ + "img/promptpay-logo.afb640a2.png";